import { Injectable } from '@angular/core';
import { HttpService } from '../../core/services/http.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private httpService: HttpService) {}

  login(data: any) {
    return this.httpService.HTTP_POST('/auth/login', data);
  }

  logout() {
    return this.httpService.HTTP_GET('/api/global/auth/logout');
  }

}